export default [
  {
    path: 'shared',
    name: 'shared-menu',
    component: () => import('@/views/Books.vue'),
    children: [
      {
        path: '/shared',
        name: 'shared',
        component: () => import('@/views/sharedv2/Menu'),
        meta: { IsParent: true },
      },
      {
        path: '/shared/Order',
        name: 'order',
        component: () => import('@/views/sharedv2/order/Wrapper'),
        children: [
          {
            path: '',
            name: 'order',
            component: () => import('@/views/sharedv2/order/Main'),
          },
          {
            path: '/shared/Order/request',
            name: 'bookRequestSearch',
            component: () => import('@/views/sharedv2/order/BookRequestSearch'),
          },
        ],
      },
      {
        path: '/shared/Manage',
        name: 'Management',
        component: () => import('@/views/sharedv2/Management/Wrapper'),
        children: [
          {
            path: '',
            name: 'Management',
            component: () => import('@/views/sharedv2/Management/Main'),
          },
        ],
      },
    ],
  },
];
